module.exports = __webpack_public_path__ + "static/media/44_B.00953e6a.png";